import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Auth from "views/Auth"
import { BindModels } from "models";
import SpinnerLoading from "components/SpinnerLoading";
import Layout from "components/Layout";
import ROUTES from "constants/routes";
import PrivateRoute from "base/PrivateRoute";
import NotFound from "views/NotFound";
import "./App.css";
import "antd/dist/antd.min.css";

function App() {
	return (
		<Suspense fallback={<SpinnerLoading />}>
			<Routes>
				<Route path="*" element={<Auth />} />
				<Route element={<Layout />}>
					{ROUTES.map(({ path, component }) => (
						<Route key={path} path={path} element={<PrivateRoute component={component} />} />
					))}
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</Suspense>
	)
}

export default BindModels(App);
